import { render } from "./DocumentosComponentsActivos.vue?vue&type=template&id=1c597f98"
import script from "./DocumentosComponentsActivos.vue?vue&type=script&lang=js"
export * from "./DocumentosComponentsActivos.vue?vue&type=script&lang=js"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__